import { useMutation } from '@tanstack/react-query';
import { PUBLIC_AI_API } from 'utils/globalApiServices';

const mutationFn = async ({ assignment_uuid, scenario_uuid, session_uuid, body = {} }) => {
  if (session_uuid) {
    const url = `/public/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/${session_uuid}`;
    const { data } = await PUBLIC_AI_API.put(url, body);
    return data;
  }
  return {};
};

const useUpdateRealPlayPublicSessionStatusMutation = () => {
  return useMutation({
    mutationFn,
  });
};

export default useUpdateRealPlayPublicSessionStatusMutation;
